import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

const ORG_TABS = [
  { label: 'Overview', path: '/organization' },
  { label: 'Members', path: '/organization/members' },
  { label: 'Teams', path: '/organization/teams' },
  { label: 'Settings', path: '/organization/settings' },
  { label: 'Audit Log', path: '/organization/audit-logs' },
];

export function OrgLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  const currentTab = ORG_TABS.findIndex((tab) => tab.path === location.pathname);

  return (
    <Box>
      <Tabs
        value={currentTab === -1 ? 0 : currentTab}
        onChange={(_, idx: number) => navigate(ORG_TABS[idx]!.path)}
        sx={{ mb: 3 }}
      >
        {ORG_TABS.map((tab) => (
          <Tab key={tab.path} label={tab.label} />
        ))}
      </Tabs>
      <Outlet />
    </Box>
  );
}
